<mat-expansion-panel *ngIf="!category.disabled" class="category mat-elevation-z0" hideToggle="true" (opened)="open = true" (closed)="open = false">
    <mat-expansion-panel-header [ngClass]="{'open': open}" class="category-header">
        <mat-panel-title class="category-title">
            <a [href]="'/#/products/' + category.state">{{category.name}}</a>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container *ngFor="let category of subCategories">
        <a class="children" *ngIf="!category.disabled" [href]="'/#/products/' + category.state">{{category.name}}</a>
    </ng-container>
</mat-expansion-panel>